const httpRequest = ( () => {
    const callApi = (url, reqPayload, headerObj, requestType = 'GET') => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest()
            xhr.open(requestType, url, true);
            for(let header in headerObj) {
                xhr.setRequestHeader(header, headerObj[header]);
            }
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);
                    let urlSplit = url.split("/")
                    let methodName = urlSplit[urlSplit.length - 1]
                    methodName = methodName.split('?')[0]
                    if(methodName && window.logAPIEvent && window.amplitude){
                        logAPIEvent(`/${methodName}`, reqPayload, response);
                    }
                    resolve(response);
                } else if(xhr.status >= 400){
                    reject(xhr.status)
                }
            }
            xhr.send(JSON.stringify(reqPayload))
        })
    }

    return {
        'get': (url, headerObj) => {
            return callApi(url, undefined, headerObj, 'GET');
        },
        'post': (url, reqPayload, headerObj) => {
            return callApi(url, reqPayload, headerObj, 'POST');
        },
        'put': (url, reqPayload, headerObj) => {
            return callApi(url, reqPayload, headerObj, 'PUT');
        }
    }
})();